import Axios from "@/plugins/Axios";

const BASE_URL = "ponto-colaboradores";

export class RegistroRemotoRegrasService {
  // Regra do próprio usuário (se pode pedir registro remoto e em quais dias)
  async minhaRegra() {
    const response = await Axios().get(`${BASE_URL}/batidas-remotas/minha-regra`);
    return response.data;
  }

  async listar() {
    const response = await Axios().get(`${BASE_URL}/admin/registro-remoto/regras`);
    return response.data;
  }

  async salvar(userId, dados) {
    const response = await Axios().put(`${BASE_URL}/admin/registro-remoto/regras/${userId}`, dados);
    return response.data;
  }
}

export default new RegistroRemotoRegrasService();
